module.exports = __webpack_public_path__ + "static/img/site-torriacg.9b4c722.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/works/site-torriacg.jpg
 ** module id = 26
 ** module chunks = 1
 **/